import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useAuction } from "@/hooks/useAuction";
import { useAuctionFx, Stamp } from "@/components/opl/AuctionFx";
import { PlayerAvatar, TeamBadge, StatusPill } from "@/components/opl/Common";
import { TimerBar } from "@/pages/LiveDisplay";
import { fmtL } from "@/lib/api";

export default function Overlay() {
  const { clubId, kind } = useParams();
  const { snap, offset, lastEvent } = useAuction({ club: clubId });
  useAuctionFx(lastEvent, false, kind === "player");
  useEffect(() => {
    document.body.style.background = "transparent";
    return () => { document.body.style.background = ""; };
  }, []);
  if (!snap) return null;
  const st = snap.state;
  const leader = snap.teams.find((t) => t.id === st.leading_team_id);
  if (kind === "teams")
    return (
      <div className="p-4 grid grid-cols-3 gap-2 w-[900px]" data-testid="overlay-teams">
        {snap.teams.map((t) => (
          <div key={t.id} className="bg-[#050B14]/90 border border-[#E5B842]/30 rounded-lg p-2 flex items-center gap-2">
            <TeamBadge team={t} size={28} /><div className="flex-1 min-w-0"><div className="text-sm font-bold truncate">{t.name}</div><div className="text-[11px] text-slate-400">{t.players_count} players</div></div>
            <span className="num font-bold text-[#F5D061]">{fmtL(t.remaining_purse)}</span>
          </div>
        ))}
      </div>
    );
  if (kind === "ticker")
    return (
      <div className="bg-[#050B14]/90 border-y border-[#E5B842]/40 px-4 py-2 whitespace-nowrap overflow-hidden text-sm" data-testid="overlay-ticker">
        <span className="eyebrow mr-4">OPL S6 · {snap.club?.name} · Sold</span>
        {snap.recent_sold.map((s) => <span key={s.id} className="mr-8">{s.player_name} → <b className="text-[#F5D061]">{s.team_name}</b> <span className="num">{fmtL(s.price)}</span></span>)}
      </div>
    );
  return (
    <div className="p-4 w-[760px]" data-testid="overlay-player">
      {snap.player && (
        <div className="relative bg-[#050B14]/90 border border-[#E5B842]/40 rounded-2xl p-4 flex items-center gap-4">
          <Stamp status={st.status} />
          <PlayerAvatar player={snap.player} size={110} />
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2"><span className="num text-[#E5B842] font-black">#{snap.player.lot_no}</span><StatusPill status={st.status} /></div>
            <div className="text-3xl font-black truncate">{snap.player.name}</div>
            <div className="text-sm text-slate-400">{snap.player.role} · Base {fmtL(snap.player.effective_base_price)}</div>
            <div className="w-64 mt-2"><TimerBar snap={snap} offset={offset} /></div>
          </div>
          <div className="text-right">
            <div className="num text-4xl font-black gold-text">{st.current_bid != null ? fmtL(st.current_bid) : "—"}</div>
            <div className="text-sm font-bold">{leader?.name || ""}</div>
          </div>
        </div>
      )}
    </div>
  );
}
